module.exports = __webpack_public_path__ + "img/gray-online-mentoring.4666091b.png";